// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/AdobeStock_352831154 1.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Main-comp{
    display: flex;
    font-family: 'Graphik', sans-serif;
    flex-direction: column;
}
.img-class-comp{

    /* margin-left: 20px;
    margin-right: 20px; */
    width: 1150px;
    /* background-color: rgba(0, 0, 0, 1); */
}
.banner-comp{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    width: 200vh;
    height: 43vh;
    border-radius: 35px;
    border: none;
    color: white;
    padding: 10px 20px;
    background-size: cover;
    background-clip: content-box;
}
.banner-heading-comp{
 font-size: 30px;
 font-weight: 600;
 font-family: Graphik;
margin: 20px;
}
.banner-text-comp{
    font-size: 14px;
    font-weight: 400;
    font-family: Graphik;
    width: 680px;
    margin: 20px;
}
.bottom-comp{
    display: flex;
    flex-direction: row;
}
.left-comp{
    display: flex;
    flex-direction: column;
}
.section-dropdown{
    width:140px;
    margin-right:20px;
    margin-top:15px;
    max-height:20px;
    
}
.multiSelectContainer li {
    padding: 10px;
    color: white;
}
multiSelectContainer input::placeholder{
color:black;
}
.checkbox {
    margin-right: 10px;
  }
.optionContainer{
    color:black;
}
.chip{
    display: none;
}
.optionListContainer {
    background-color:#202342;
    border-radius: 4px;
    font-size: 12px;
    color:black;
    margin-top: 1px;
    position: absolute;
    width: 100%;
    z-index: 2;
}
.searchWrapper{
    max-width:150px;
    background-color:white;
    border-radius:10px;
    border:1px solid black;
    color:black;
    font-size:12px;
    overflow:hidden;
    max-height:26px;
}
  
.title-box-comp{
    width:550px;
    font-size: 13px;
    border-radius:5px;
    border: 2px solid white;
    margin-left:20px;
    margin-top:5px;
}
.right-comp{
    background-color:rgba(255, 255, 255, 0.03);
    border-radius:10px;
    width:100%;
    margin-right:20px;
    margin-top:10px;
    margin-left:35px;
}
.under-generate-comp{
    background-color:rgba(255, 255, 255, 0.1);
    margin-top:10px;
    width:100%;  
    margin-left: 20px;
    border-radius: 10px;
}
.loader-c {
    display: flex;
    margin-left:150px;
    justify-content: center;
    align-items: center;
    height: 40px;
  }
  
  .dot-cq {
    width: 10px;
    height: 10px;
    margin: 0 5px;
    border-radius: 50%;
    display: inline-block;
    animation: bounce 1.4s infinite ease-in-out;
  }
  
  .red-c {
    background-color: red; /* Red color */
    animation-delay: -0.32s;
  }
  
  .green-c {
    background-color:green; /* Green color */
    animation-delay: -0.16s;
  }
  .blue-c {
    background-color: blue; /* Blue color */
   
  }
  .f-comp{
    color:white;
    font-weight:500;
    padding-left:10px;
    padding-bottom:5px;
    padding-top:5px;
  }
  .f2-comp{
    color:white;
    font-weight:500;
    padding-left:20px;
    padding-bottom:5px;
    padding-top:5px;
  }
  .report-table{
    max-height:400px;
   
    margin-left:20px;
   
  }
  .report-table thead {
      padding-left: 15px;
    position: sticky;
    top: 0;
    background-color: #202342; /* Set your desired header background color */
    color: white; /* Set your desired header text color */
  }
 .report-table-container{
    overflow-y: scroll;
    max-height: 350px;
    max-width: 1150px;
 }
  .report-table th{
   padding-left: 30px;
    height:40px;
    overflow: None;
    color:white;
    font-size: 14px;
    background-color:rgba(255, 255, 255, 0.1);
font-style: normal;
font-weight: 500;
line-height: normal;
    border:1px solid rgba(0, 0, 0, 0.10);
    border-bottom:1px solid rgba(0, 0, 0, 0.10);
  }
.report-table td {
  border:  1px solid rgba(0, 0, 0, 0.10); /* Add border to individual cells if desired */
  padding: 8px; /* Add padding to cells for spacing */
  font-family: 'Graphik', sans-serif;
  color: white;
  text-align: left;
  font-size: 12px;

font-style: normal;
font-weight: 300;
line-height: normal;
}
  .f3-comp{
    color:white;
    font-weight:500;
    padding-left:20px;
    padding-bottom:5px;
    padding-top:15px;
  }
.above-comp{
    padding-bottom:30px;
    border-bottom:1px solid #8392B6;
}
.r2-comp{
    display:flex;
    flex-direction:row;
    padding-left:10px;
}
.p-comp{
    color:white;
    background-color:#D8AC1B;
    flex-shrink: 0;
    padding-left:10px;
    font-size:10px;
    padding-top:3px;
    height:20px;
    padding-right:10px;   
    border-radius:12px;
    margin-right:10px;
}
.p1-comp{
    color:white;
    padding-top:3px;
    background-color:#24B600;
    flex-shrink: 0;
    padding-left:10px;
    font-size:10px;
    height:20px;
    padding-right:10px;   
    border-radius:12px;
    margin-right:10px;
}
.d-comp{
    color:white;
    font-size:12px;
    padding-bottom:5px;
}
.generate-comp{
    margin-left: 20px;
    font-size: 15px;
    font-weight: 500;
    margin-top: 10px;
    color: white;
}
.r1-comp{
    display:flex;
    flex-direction:row;
}
.n2-comp{
    display:flex;
    margin-top:10px;
    flex-direction:row;
}
.in-comp{
    margin-top:8px;
    padding-right:200px;
    font-size:13px;
    padding-top:10px;
    font-weight: 300;
    padding-left:80px;
    color:white;
}
.drop-comp {
    width: 200px;
    border-radius: 10px;
    height: 25px;
    margin-top: 15px;
}
.ref-comp{
    color: #FFF;
padding-left:20px;
padding-top:15px;
font-size: 14px;
padding-right:10px;
font-style: normal;
font-weight: 500;
line-height: normal;
}
.file-comp{
 color: #FFF;
padding-top:18px;
font-size: 12px;
padding-right:150px;
font-style: normal;
font-weight: 300;
line-height: normal;
}
.n1-comp{
   background-color: rgba(0, 0, 0, 0.10);
   display:flex;
   border-radius:5px;
   margin-top:10px;
   height:50px;
   width:1140px;
   flex-direction:row;
   margin-left:20px;
   color:white;
    flex-shrink: 0;
}
.generate1-comp{
    margin-left: 10px;
    padding-bottom:10px;
    font-size: 15px;
    font-weight: 500;
    border-bottom:1px solid #8392B6;
    margin-top: 5px;
    color: white;
}
.Heading-comp{
    color:#fff;
    font-size: 12px;
    display: flex;
    flex-direction: row;
    padding: 20px
}
.mining-comp{
    color:#6B5CD1;
    padding-right: 5px;
}
.button-comp{
    text-align:right;
    margin-top:10px;
   margin-bottom:10px;
    border-radius:10px;
    margin-right:30px;
}
.sub-heading-comp{
    margin-left: 20px;
    font-size: 15px;
    font-weight: 400;
    margin-top: 10px;
    color: white;
}
.b-c{
    background-color:#6B5CD1;
    border: 2px solid #6B5CD1;
    color:white;
    border-radius:26px;
    width:120px;
    margin-bottom: 20px;
}
.b-c:hover{
    background-color: #343434;
    border: 2px solid #343434;
}
.b1-c{
    background-color:#6B5CD1;
    border: 2px solid #6B5CD1;
    margin-left:60px;
    color:white;
    margin-top:15px;
    margin-right:20px;
    height:30px;
    border-radius:26px;
    width:120px;
}
.b1-c:hover{
    background-color: #343434;
    border: 2px solid #343434;
}
.b2-c{
    background-color:#6B5CD1;
    border: 2px solid #6B5CD1;
    color:white;
 
    margin-top:10px;
    margin-bottom:10px;
    margin-left:10px;
    height:30px;
    border-radius:26px;
    width:120px;
}
.b2-c:hover{
    background-color: #343434;
    border: 2px solid #343434;
}
.b3-c{
    background-color:#6B5CD1;
    text-decoration: none;
    border: 2px solid #6B5CD1;
    color:white;
 
    margin:10px;
    height:30px;
    border-radius:26px;
    width:120px;
}
.b3-c:hover{
    background-color: #343434;
    border: 2px solid #343434;
}
.dropdown-comp{
    display: flex;
    margin-top:10px;
    flex-direction: row;
}
.img-comp{
    width:60%;
    margin-left:10px;
}
.first-select-comp{
    display: flex;
    flex-direction: column;
}
.first-input-comp {
    /* display: flex; */
    /* margin-left: 20px; */
     width: 270px; 
    height: 25px;
    flex-direction: row;
}`, "",{"version":3,"sources":["webpack://./src/CompIQ.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kCAAkC;IAClC,sBAAsB;AAC1B;AACA;;IAEI;yBACqB;IACrB,aAAa;IACb,wCAAwC;AAC5C;AACA;IACI,yDAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,4BAA4B;AAChC;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,oBAAoB;AACrB,YAAY;AACZ;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,eAAe;;AAEnB;AACA;IACI,aAAa;IACb,YAAY;AAChB;AACA;AACA,WAAW;AACX;AACA;IACI,kBAAkB;EACpB;AACF;IACI,WAAW;AACf;AACA;IACI,aAAa;AACjB;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;AACA;IACI,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,0CAA0C;IAC1C,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,yCAAyC;IACzC,eAAe;IACf,UAAU;IACV,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,2CAA2C;EAC7C;;EAEA;IACE,qBAAqB,EAAE,cAAc;IACrC,uBAAuB;EACzB;;EAEA;IACE,sBAAsB,EAAE,gBAAgB;IACxC,uBAAuB;EACzB;EACA;IACE,sBAAsB,EAAE,eAAe;;EAEzC;EACA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,gBAAgB;;IAEhB,gBAAgB;;EAElB;EACA;MACI,kBAAkB;IACpB,gBAAgB;IAChB,MAAM;IACN,yBAAyB,EAAE,6CAA6C;IACxE,YAAY,EAAE,uCAAuC;EACvD;CACD;IACG,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;CACpB;EACC;GACC,kBAAkB;IACjB,WAAW;IACX,cAAc;IACd,WAAW;IACX,eAAe;IACf,yCAAyC;AAC7C,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;IACf,oCAAoC;IACpC,2CAA2C;EAC7C;AACF;EACE,sCAAsC,EAAE,8CAA8C;EACtF,YAAY,EAAE,qCAAqC;EACnD,kCAAkC;EAClC,YAAY;EACZ,gBAAgB;EAChB,eAAe;;AAEjB,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB;EACE;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;AACF;IACI,mBAAmB;IACnB,+BAA+B;AACnC;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,wBAAwB;IACxB,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,eAAe;IACf,wBAAwB;IACxB,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,WAAW;AACf,iBAAiB;AACjB,gBAAgB;AAChB,eAAe;AACf,kBAAkB;AAClB,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB;AACA;CACC,WAAW;AACZ,gBAAgB;AAChB,eAAe;AACf,mBAAmB;AACnB,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB;AACA;GACG,qCAAqC;GACrC,YAAY;GACZ,iBAAiB;GACjB,eAAe;GACf,WAAW;GACX,YAAY;GACZ,kBAAkB;GAClB,gBAAgB;GAChB,WAAW;IACV,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,eAAe;IACf,YAAY;AAChB;AACA;IACI,UAAU;IACV,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB;AACJ;AACA;IACI,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,eAAe;GAChB,kBAAkB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,WAAW;;IAEX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,yBAAyB;IACzB,WAAW;;IAEX,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,uBAAuB;KACtB,YAAY;IACb,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":[".Main-comp{\n    display: flex;\n    font-family: 'Graphik', sans-serif;\n    flex-direction: column;\n}\n.img-class-comp{\n\n    /* margin-left: 20px;\n    margin-right: 20px; */\n    width: 1150px;\n    /* background-color: rgba(0, 0, 0, 1); */\n}\n.banner-comp{\n    background-image: url('./images/AdobeStock_352831154\\ 1.png');\n    width: 200vh;\n    height: 43vh;\n    border-radius: 35px;\n    border: none;\n    color: white;\n    padding: 10px 20px;\n    background-size: cover;\n    background-clip: content-box;\n}\n.banner-heading-comp{\n font-size: 30px;\n font-weight: 600;\n font-family: Graphik;\nmargin: 20px;\n}\n.banner-text-comp{\n    font-size: 14px;\n    font-weight: 400;\n    font-family: Graphik;\n    width: 680px;\n    margin: 20px;\n}\n.bottom-comp{\n    display: flex;\n    flex-direction: row;\n}\n.left-comp{\n    display: flex;\n    flex-direction: column;\n}\n.section-dropdown{\n    width:140px;\n    margin-right:20px;\n    margin-top:15px;\n    max-height:20px;\n    \n}\n.multiSelectContainer li {\n    padding: 10px;\n    color: white;\n}\nmultiSelectContainer input::placeholder{\ncolor:black;\n}\n.checkbox {\n    margin-right: 10px;\n  }\n.optionContainer{\n    color:black;\n}\n.chip{\n    display: none;\n}\n.optionListContainer {\n    background-color:#202342;\n    border-radius: 4px;\n    font-size: 12px;\n    color:black;\n    margin-top: 1px;\n    position: absolute;\n    width: 100%;\n    z-index: 2;\n}\n.searchWrapper{\n    max-width:150px;\n    background-color:white;\n    border-radius:10px;\n    border:1px solid black;\n    color:black;\n    font-size:12px;\n    overflow:hidden;\n    max-height:26px;\n}\n  \n.title-box-comp{\n    width:550px;\n    font-size: 13px;\n    border-radius:5px;\n    border: 2px solid white;\n    margin-left:20px;\n    margin-top:5px;\n}\n.right-comp{\n    background-color:rgba(255, 255, 255, 0.03);\n    border-radius:10px;\n    width:100%;\n    margin-right:20px;\n    margin-top:10px;\n    margin-left:35px;\n}\n.under-generate-comp{\n    background-color:rgba(255, 255, 255, 0.1);\n    margin-top:10px;\n    width:100%;  \n    margin-left: 20px;\n    border-radius: 10px;\n}\n.loader-c {\n    display: flex;\n    margin-left:150px;\n    justify-content: center;\n    align-items: center;\n    height: 40px;\n  }\n  \n  .dot-cq {\n    width: 10px;\n    height: 10px;\n    margin: 0 5px;\n    border-radius: 50%;\n    display: inline-block;\n    animation: bounce 1.4s infinite ease-in-out;\n  }\n  \n  .red-c {\n    background-color: red; /* Red color */\n    animation-delay: -0.32s;\n  }\n  \n  .green-c {\n    background-color:green; /* Green color */\n    animation-delay: -0.16s;\n  }\n  .blue-c {\n    background-color: blue; /* Blue color */\n   \n  }\n  .f-comp{\n    color:white;\n    font-weight:500;\n    padding-left:10px;\n    padding-bottom:5px;\n    padding-top:5px;\n  }\n  .f2-comp{\n    color:white;\n    font-weight:500;\n    padding-left:20px;\n    padding-bottom:5px;\n    padding-top:5px;\n  }\n  .report-table{\n    max-height:400px;\n   \n    margin-left:20px;\n   \n  }\n  .report-table thead {\n      padding-left: 15px;\n    position: sticky;\n    top: 0;\n    background-color: #202342; /* Set your desired header background color */\n    color: white; /* Set your desired header text color */\n  }\n .report-table-container{\n    overflow-y: scroll;\n    max-height: 350px;\n    max-width: 1150px;\n }\n  .report-table th{\n   padding-left: 30px;\n    height:40px;\n    overflow: None;\n    color:white;\n    font-size: 14px;\n    background-color:rgba(255, 255, 255, 0.1);\nfont-style: normal;\nfont-weight: 500;\nline-height: normal;\n    border:1px solid rgba(0, 0, 0, 0.10);\n    border-bottom:1px solid rgba(0, 0, 0, 0.10);\n  }\n.report-table td {\n  border:  1px solid rgba(0, 0, 0, 0.10); /* Add border to individual cells if desired */\n  padding: 8px; /* Add padding to cells for spacing */\n  font-family: 'Graphik', sans-serif;\n  color: white;\n  text-align: left;\n  font-size: 12px;\n\nfont-style: normal;\nfont-weight: 300;\nline-height: normal;\n}\n  .f3-comp{\n    color:white;\n    font-weight:500;\n    padding-left:20px;\n    padding-bottom:5px;\n    padding-top:15px;\n  }\n.above-comp{\n    padding-bottom:30px;\n    border-bottom:1px solid #8392B6;\n}\n.r2-comp{\n    display:flex;\n    flex-direction:row;\n    padding-left:10px;\n}\n.p-comp{\n    color:white;\n    background-color:#D8AC1B;\n    flex-shrink: 0;\n    padding-left:10px;\n    font-size:10px;\n    padding-top:3px;\n    height:20px;\n    padding-right:10px;   \n    border-radius:12px;\n    margin-right:10px;\n}\n.p1-comp{\n    color:white;\n    padding-top:3px;\n    background-color:#24B600;\n    flex-shrink: 0;\n    padding-left:10px;\n    font-size:10px;\n    height:20px;\n    padding-right:10px;   \n    border-radius:12px;\n    margin-right:10px;\n}\n.d-comp{\n    color:white;\n    font-size:12px;\n    padding-bottom:5px;\n}\n.generate-comp{\n    margin-left: 20px;\n    font-size: 15px;\n    font-weight: 500;\n    margin-top: 10px;\n    color: white;\n}\n.r1-comp{\n    display:flex;\n    flex-direction:row;\n}\n.n2-comp{\n    display:flex;\n    margin-top:10px;\n    flex-direction:row;\n}\n.in-comp{\n    margin-top:8px;\n    padding-right:200px;\n    font-size:13px;\n    padding-top:10px;\n    font-weight: 300;\n    padding-left:80px;\n    color:white;\n}\n.drop-comp {\n    width: 200px;\n    border-radius: 10px;\n    height: 25px;\n    margin-top: 15px;\n}\n.ref-comp{\n    color: #FFF;\npadding-left:20px;\npadding-top:15px;\nfont-size: 14px;\npadding-right:10px;\nfont-style: normal;\nfont-weight: 500;\nline-height: normal;\n}\n.file-comp{\n color: #FFF;\npadding-top:18px;\nfont-size: 12px;\npadding-right:150px;\nfont-style: normal;\nfont-weight: 300;\nline-height: normal;\n}\n.n1-comp{\n   background-color: rgba(0, 0, 0, 0.10);\n   display:flex;\n   border-radius:5px;\n   margin-top:10px;\n   height:50px;\n   width:1140px;\n   flex-direction:row;\n   margin-left:20px;\n   color:white;\n    flex-shrink: 0;\n}\n.generate1-comp{\n    margin-left: 10px;\n    padding-bottom:10px;\n    font-size: 15px;\n    font-weight: 500;\n    border-bottom:1px solid #8392B6;\n    margin-top: 5px;\n    color: white;\n}\n.Heading-comp{\n    color:#fff;\n    font-size: 12px;\n    display: flex;\n    flex-direction: row;\n    padding: 20px\n}\n.mining-comp{\n    color:#6B5CD1;\n    padding-right: 5px;\n}\n.button-comp{\n    text-align:right;\n    margin-top:10px;\n   margin-bottom:10px;\n    border-radius:10px;\n    margin-right:30px;\n}\n.sub-heading-comp{\n    margin-left: 20px;\n    font-size: 15px;\n    font-weight: 400;\n    margin-top: 10px;\n    color: white;\n}\n.b-c{\n    background-color:#6B5CD1;\n    border: 2px solid #6B5CD1;\n    color:white;\n    border-radius:26px;\n    width:120px;\n    margin-bottom: 20px;\n}\n.b-c:hover{\n    background-color: #343434;\n    border: 2px solid #343434;\n}\n.b1-c{\n    background-color:#6B5CD1;\n    border: 2px solid #6B5CD1;\n    margin-left:60px;\n    color:white;\n    margin-top:15px;\n    margin-right:20px;\n    height:30px;\n    border-radius:26px;\n    width:120px;\n}\n.b1-c:hover{\n    background-color: #343434;\n    border: 2px solid #343434;\n}\n.b2-c{\n    background-color:#6B5CD1;\n    border: 2px solid #6B5CD1;\n    color:white;\n \n    margin-top:10px;\n    margin-bottom:10px;\n    margin-left:10px;\n    height:30px;\n    border-radius:26px;\n    width:120px;\n}\n.b2-c:hover{\n    background-color: #343434;\n    border: 2px solid #343434;\n}\n.b3-c{\n    background-color:#6B5CD1;\n    text-decoration: none;\n    border: 2px solid #6B5CD1;\n    color:white;\n \n    margin:10px;\n    height:30px;\n    border-radius:26px;\n    width:120px;\n}\n.b3-c:hover{\n    background-color: #343434;\n    border: 2px solid #343434;\n}\n.dropdown-comp{\n    display: flex;\n    margin-top:10px;\n    flex-direction: row;\n}\n.img-comp{\n    width:60%;\n    margin-left:10px;\n}\n.first-select-comp{\n    display: flex;\n    flex-direction: column;\n}\n.first-input-comp {\n    /* display: flex; */\n    /* margin-left: 20px; */\n     width: 270px; \n    height: 25px;\n    flex-direction: row;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
